
// Vue
import { defineComponent, PropType } from 'vue';
import type { StandardPolicy } from '@white-label-types/parking-booking';
import { mapState } from 'pinia';
import { useCartCheckoutStore } from '@white-label-store/cart-checkout';

// Helpers
import { getAppVariable } from '@white-label-helper/get-app-variable';

export default defineComponent({
  name: 'StandardPolicies',

  components: {
    IconShield: () => import('@white-label-icon/icon-shield'),
  },

  props: {
    bundleProductsStandardPolicies: {
      type: Array as PropType<StandardPolicy[]>,
      default: function () {
        return [];
      },
    },
    nonBundleProductsStandardPolicies: {
      type: Array as PropType<StandardPolicy[]>,
      default: function () {
        return [];
      },
    },
    isBookingFeeCharged: {
      type: Boolean,
      required: true,
      default: false,
    },
    bundleNameProp: {
      type: String,
      default: '',
    }
  },

  computed: {
    ...mapState(useCartCheckoutStore, {
      readCartBundle: 'readCartBundle'
    }),
    cancellationPolicyTitle(): string {
      return this.$t('cancellationAndAmendment.cancellationPolicy').toLowerCase();
    },
    amendmentPolicyTitle(): string {
      return this.$t('cancellationAndAmendment.amendmentPolicy').toLowerCase();
    },
    bundleName(): string {
      return this.readCartBundle?.name || this.bundleNameProp || '';
    },
    isBundleProductsCancelTermsEqual(): boolean {
      return getAppVariable('is_sell_bundles_enabled')
        && this.bundleProductsStandardPolicies.every((item) => {
          return item.cancellation_policy === this.bundleProductsStandardPolicies[0].cancellation_policy;
        });
    },
    isBundleCannotBeCancelled(): boolean {
      return getAppVariable('is_sell_bundles_enabled')
        && this.bundleProductsStandardPolicies.some((item) => {
          // TODO temporary solution until ECOM-3362 implemented
          return item.cancellation_policy.startsWith('No cancellation up to 0 hour before arrival')
            || item.cancellation_policy.startsWith('No cancellation up to 0 day before arrival');
        });
    },
    bundleCancellationPolicy(): string {
      if (this.isBundleCannotBeCancelled) {
        // TODO temporary solution until ECOM-3362 implemented
        return 'No cancellation up to 0 hour before arrival';
      }
      if (this.isBundleProductsCancelTermsEqual) {
        return `
          ${this.$t('cancellationAndAmendment.bundleCannotBeCancelledSeparately', { bundleName: this.bundleName })}.
          ${this.bundleProductsStandardPolicies[0].cancellation_policy}
        `;
      }
      return this.$t('cancellationAndAmendment.bundleItemsCancellation', { bundleName: this.bundleName });
    },
  },
});
